import { storage } from '../client/index';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export const uploadFile = async (filename, file) => {
  try {
    const filePath = ref(storage, `files/${filename}`);
    await uploadBytes(filePath, file);
    const url = await getDownloadURL(filePath);
    return url;
  } catch (err) {
    return err;
  }
}

export const getFile = async (filename) => {
  try {
    const filePath = ref(storage, `files/${filename}`);
    const fileBlob = await getDownloadURL(filePath);
    return fileBlob;
  } catch (err) {
    console.error({ err });
    return null;
  }
}